import React, {createContext, useContext, useReducer, useState} from 'react';
import { useApp } from '../AppProvider';
import { getVoucher, sendData } from '../../Service/api';
import { IQuestion, IData } from '../../interfaces';
import {dataReducer, INITIAL_STATE} from './reducer';
import { SAVE_DATA } from './types';
import { onlyNumber, validateCpf, validateEmail } from '../../utils';

interface IContext {
  data: IData,
  saveInList(questions: IQuestion[], deleteInList?: number[]): void,
  deleteInList(arrayIndex: number[]): void,
  getData(index: number): IQuestion,
  saveData(data: IData): void,
  sendRegister(): Promise<boolean | undefined>,
  isLoading: string,
  setIsLoading(value: string): void
  voucher: string,
  setVoucher(value: string): void
}

const Context = createContext({} as IContext);

export default function RegisterProvider({children}: {children: React.ReactNode}) {
  const {setAlert} = useApp();
  const [data, dispatch] = useReducer(dataReducer, INITIAL_STATE);
  const [isLoading, setIsLoading] = useState('');
  const [voucher, setVoucher] = useState('');

  const saveData = (data: IData) => {
    dispatch({type: SAVE_DATA, payload: {...data}});
  }

  const saveInList = (questions: IQuestion[], deleteInList: number[] = []) => {
    let newList = data?.list || [];
    questions?.map(({index, question, answer}: IQuestion) => {
      if(data?.list?.some((q: IQuestion) => q.index === index)){
        newList = data?.list?.map((q: IQuestion) => {
          if(q.index === index) return {question, answer, index};
          return q;
        });
      }else{
        newList.push({question, answer, index});
      }
      return {index, question, answer};
    })

    newList = newList?.filter(({index}: {index: number}) => {
      return !deleteInList?.some(i => i === index);
    });
    
    dispatch({type: SAVE_DATA, payload: {...data, list: newList}})
  }

  const deleteInList = (arrayIndex: number[]) => {
    let newList = data?.list?.filter(({index}: {index: number}) => {
      return !arrayIndex.some(i => i === index);
    });
    dispatch({type: SAVE_DATA, payload: {...data, list: newList}})
  }

  const getData = (index: number): IQuestion | any => {
    return data?.list?.find((q: IQuestion) => q.index === index) || null;
  }

  const sendRegister = async (): Promise<boolean | undefined> => {
    if(!data?.rg || data?.rg.length < 12){
      setAlert({type: 'error', message: 'Digite um RG válido.'});
      setTimeout(() => setAlert({type: 'error', message: ''}), 5000);
      setIsLoading(''); 
      return false;
    }

    if(!data?.cpf || !validateCpf(onlyNumber(data?.cpf)) ){
      setAlert({type: 'error', message: 'Digite um CPF válido.'});
      setTimeout(() => setAlert({type: 'error', message: ''}), 5000);
      setIsLoading(''); 
      return false;
    }

    if(!data.phone || data?.phone?.length < 14){
      setAlert({type: 'error', message: 'Digite um número de telefone válido.'});
      setTimeout(() => setAlert({type: 'error', message: ''}), 5000);
      setIsLoading('');
      return false
    }

    if(!data?.email || !validateEmail(data?.email)){
      setAlert({type: 'error', message: 'Digite um e-mail válido.'});
      setTimeout(() => setAlert({type: 'error', message: ''}), 5000);
      setIsLoading('');
      return false
    }

    if(data?.email !== '' && data?.phone !== '' && data?.firstName !== '' && data?.lastName !== ''){
      setIsLoading('Carregando...');
      const response = await getVoucher(data);
      setIsLoading('Gerando cupom...');
      if(response?.error){
        setAlert({message: response?.msg, type: 'warning'});
        setTimeout(() => setAlert({message: '', type: 'warning'}), 6000);
        setIsLoading('');
        return false;
      }else{ 
        const dataSetPartnerId = data?.list?.map((item: IQuestion) => {
          item.partnerId = 126;
          return item;
        })
        await sendData({...data, list: dataSetPartnerId});
        setVoucher(response?.invitation_code);
        setIsLoading('');
        return true;
      }
    }
  }

  return (
    <Context.Provider value={{
      data,
      saveInList,
      deleteInList,
      getData,
      saveData,
      sendRegister,
      isLoading,
      setIsLoading,
      voucher,
      setVoucher
    }}> 
      {children}
    </Context.Provider>
  );
}

export function useRegister() {
  const context: IContext = useContext(Context);
  return context;
}